import useUserStore from '@/stores/UserStore';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';

import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';

const FollowerLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    opensFeatureEnabled,
    personalizeOpensEnabled,
    selfServiceOpensEnabled,
    user,
  } = useUserStore(
    useShallow((state) => ({
      opensFeatureEnabled: state.opensFeatureEnabled,
      personalizeOpensEnabled: state.personalizeOpensEnabled,
      selfServiceOpensEnabled: state.selfServiceOpensEnabled,
      user: state.user,
    }))
  );
  const isStats = location.pathname === '/followers';
  const isSettings = location.pathname.startsWith('/followers/config');
  const isSelfServiceSettings = location.pathname.startsWith(
    '/followers/self-service/config'
  );
  const isAdmin = user?.role === 'admin';
  return (
    <div className='h-svh'>
      <div className='flex h-full flex-col'>
        {/* Header */}
        <div className='flex-shrink-0 border-b bg-background px-6 py-4'>
          <div className='space-y-1'>
            <div className='flex items-center justify-between'>
              <div>
                <h1 className='text-xl font-bold tracking-tight'>
                  {isStats
                    ? 'Opens · Stats'
                    : isSettings || isSelfServiceSettings
                      ? selfServiceOpensEnabled
                        ? 'Self-Service Opens · Settings'
                        : 'Opens · Settings'
                      : selfServiceOpensEnabled
                        ? 'Self-Service Opens'
                        : 'Personalize Opens'}
                </h1>
                <p className='text-sm text-muted-foreground'>
                  {isStats
                    ? 'Analyze opening messages sent and response rates'
                    : isSettings || isSelfServiceSettings
                      ? selfServiceOpensEnabled
                        ? 'Configure your personalized opens prompt'
                        : 'Configure opens behavior and filters'
                      : selfServiceOpensEnabled
                        ? 'Review and manage your personalized opening messages'
                        : 'Review and approve AI-generated personalized opening messages'}
                </p>
              </div>
              <div className='flex items-center gap-2'>
                <Tabs
                  value={
                    isStats
                      ? 'stats'
                      : isSettings || isSelfServiceSettings
                        ? 'settings'
                        : 'opens'
                  }
                  onValueChange={(v) => {
                    if (selfServiceOpensEnabled) {
                      navigate(
                        v === 'stats'
                          ? '/followers'
                          : v === 'opens'
                            ? '/followers/self-service/opens'
                            : '/followers/self-service/config'
                      );
                    } else {
                      navigate(
                        v === 'stats'
                          ? '/followers'
                          : v === 'opens'
                            ? '/followers/list'
                            : '/followers/config'
                      );
                    }
                  }}
                  className='w-auto'
                >
                  <TabsList
                    className={`grid ${
                      (personalizeOpensEnabled || selfServiceOpensEnabled) &&
                      ((opensFeatureEnabled && isAdmin) ||
                        selfServiceOpensEnabled)
                        ? 'grid-cols-3'
                        : personalizeOpensEnabled ||
                            selfServiceOpensEnabled ||
                            (opensFeatureEnabled && isAdmin) ||
                            selfServiceOpensEnabled
                          ? 'grid-cols-2'
                          : 'grid-cols-1'
                    }`}
                  >
                    <TabsTrigger value='stats' className='text-xs sm:text-sm'>
                      Stats
                    </TabsTrigger>
                    {(personalizeOpensEnabled || selfServiceOpensEnabled) && (
                      <TabsTrigger value='opens' className='text-xs sm:text-sm'>
                        Opens
                      </TabsTrigger>
                    )}
                    {((opensFeatureEnabled && isAdmin) ||
                      selfServiceOpensEnabled) && (
                      <TabsTrigger
                        value='settings'
                        className='text-xs sm:text-sm'
                      >
                        Settings
                      </TabsTrigger>
                    )}
                  </TabsList>
                </Tabs>
              </div>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className='min-h-0 flex-1'>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default FollowerLayout;
